/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EditViewRequest
 */
export interface EditViewRequest {
  /**
   *
   * @type {string}
   * @memberof EditViewRequest
   */
  savedViewId: string;
  /**
   *
   * @type {string}
   * @memberof EditViewRequest
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditViewRequest
   */
  description?: string | null;
}

/**
 * Check if a given object implements the EditViewRequest interface.
 */
export function instanceOfEditViewRequest(
  value: object,
): value is EditViewRequest {
  if (!("savedViewId" in value) || value["savedViewId"] === undefined)
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function EditViewRequestFromJSON(json: any): EditViewRequest {
  return EditViewRequestFromJSONTyped(json, false);
}

export function EditViewRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EditViewRequest {
  if (json == null) {
    return json;
  }
  return {
    savedViewId: json["savedViewId"],
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
  };
}

export function EditViewRequestToJSON(json: any): EditViewRequest {
  return EditViewRequestToJSONTyped(json, false);
}

export function EditViewRequestToJSONTyped(
  value?: EditViewRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    savedViewId: value["savedViewId"],
    name: value["name"],
    description: value["description"],
  };
}
